import React, { useState } from 'react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const TabItem = props => <div {...props} />;

export const Tabs = ({ defaultIndex = 0, onTabClick, children }) => {
  const [bindIndex, setBindIndex] = useState(defaultIndex);

  const changeTab = newIndex => {
    if (typeof onItemClick === 'function') onItemClick(itemIndex);
    setBindIndex(newIndex);
  };

  const items = React.Children.toArray(children)

  return (
    <div>
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-0" aria-label="Tabs">
          {items.map(({ props: { index, label } }) => (
            <button
              key={`tab-btn-${index}`}
              onClick={() => changeTab(index)}
              className={classNames(
                bindIndex === index
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'whitespace-nowrap py-2 px-2 border-b-2 font-medium text-sm'
              )}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>

      <div>
        {items.map(({ props }) => (
          <div
            {...props}
            className={`tab-content ${
              bindIndex === props.index ? 'block' : 'hidden'
            }`}
            key={`tab-content-${props.index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Tabs;

